import { useState } from "react";
import axios from "axios";
import { Check, CheckCircle2, Pencil, X } from "lucide-react";
import { API } from "../lib/apiClient";
import { Modal } from "./common";
import { CompanyLogo } from "../lib/companies";

const tl = (v) => (v || v === 0 ? `₺${Number(v).toLocaleString("tr-TR", { maximumFractionDigits: 0 })}` : "—");
const trd = (s) => (s ? s.slice(0, 10).split("-").reverse().join(".") : "—");
export const offersOf = (q) => (q.offers?.length ? q.offers : [{ id: "", company: q.company, quoteNo: q.quoteNo, premium: q.premium, netPremium: q.netPremium }]);
export const needsCheck = (q) => q.customerChoiceAt && !q.agentConfirmedAt && q.status === "Kabul";

export function QuoteCheckModal({ quote: q, onUpdated, onEdit, onConvert, onClose }) {
  const [busy, setBusy] = useState("");
  const offers = offersOf(q);
  const chosen = offers.find((o) => o.id && o.id === q.chosenOfferId) || offers.find((o) => o.company === q.company) || offers[0];
  const others = offers.filter((o) => o !== chosen);
  const act = async (action) => {
    if (action === "reject" && !window.confirm("Teklif reddedildi olarak işaretlensin mi?")) return;
    setBusy(action);
    try {
      const { data } = await axios.post(`${API}/quotes/${q.id}/agent-check`, { action });
      onUpdated(data); onClose();
      if (action === "confirm" && onConvert && window.confirm("Kontrol tamamlandı. Teklif şimdi poliçeye dönüştürülsün mü?")) onConvert(data);
    } catch (e) { window.alert(e?.response?.data?.detail || "İşlem başarısız"); } finally { setBusy(""); }
  };
  const rows = [["Teklif tarihi", trd(q.createdAt)], ["Geçerlilik", trd(q.expiryDate)], ["Plaka", q.plate], ["Ruhsat seri", q.ruhsatSeriNo], ["T.C.", q.tcKimlik]].filter(([, v]) => v && v !== "—");
  return (
    <Modal title={`Son Kontrol · ${(q.customerName || "").toLocaleUpperCase("tr")}`} onClose={onClose}>
      <div className="qcheck" data-testid="quote-check-modal">
        <div className="qcheck-chosen" data-testid="quote-check-chosen">
          <small>MÜŞTERİNİN SEÇTİĞİ TEKLİF</small>
          <div className="qcheck-chosen-row">
            <CompanyLogo name={chosen.company} size={40} />
            <div className="qcheck-co"><strong>{chosen.company || "—"}</strong><span>{q.branch} Sigortası{chosen.quoteNo ? ` · No: ${chosen.quoteNo}` : ""}</span></div>
            <div className="qcheck-price"><b data-testid="quote-check-premium">{tl(chosen.premium)}</b>{chosen.netPremium ? <span>Net {tl(chosen.netPremium)}</span> : null}</div>
          </div>
          {q.customerChoiceNote && <p className="qcheck-note">“{q.customerChoiceNote}”</p>}
        </div>
        {rows.length > 0 && (<><h4>POLİÇE BİLGİLERİ</h4><dl className="qcheck-rows">{rows.map(([l, v]) => <div key={l}><dt>{l}</dt><dd>{v}</dd></div>)}</dl></>)}
        {others.length > 0 && (<><h4>DİĞER TEKLİFLER</h4><ul className="qcheck-others">{others.map((o) => <li key={o.id || o.company}><CompanyLogo name={o.company} size={20} /><span>{o.company}</span><b>{tl(o.premium)}</b></li>)}</ul></>)}
        <div className="qcheck-actions">
          <button type="button" className="outline-button" onClick={() => { onClose(); onEdit(q); }} data-testid="quote-check-edit"><Pencil size={14} /> Teklifi Düzenle</button>
          <button type="button" className="outline-button danger" disabled={!!busy} onClick={() => act("reject")} data-testid="quote-check-reject"><X size={14} /> Reddet</button>
        </div>
        <button type="button" className="qcheck-confirm" disabled={!!busy} onClick={() => act("confirm")} data-testid="quote-check-confirm"><Check size={16} /> Kontrol Ettim, Onayla</button>
      </div>
    </Modal>
  );
}

export function PendingChoices({ quotes, onOpen }) {
  const list = quotes.filter(needsCheck);
  if (!list.length) return null;
  return (
    <section className="pending-choices" data-testid="pending-choices">
      <div className="pending-choices-head"><CheckCircle2 size={16} /> <strong>Müşteri seçimi bekleyen kontrol</strong><b>{list.length}</b></div>
      <ul>{list.slice(0, 5).map((q) => (
        <li key={q.id}><button type="button" onClick={() => onOpen(q.id)} data-testid={`pending-choice-${q.id}`}>
          <CompanyLogo name={q.company} size={22} /><span><strong>{q.customerName}</strong> {q.branch} · {q.company}</span><b>{tl(q.premium)}</b><em>Kontrol et</em>
        </button></li>
      ))}</ul>
    </section>
  );
}
